import React from 'react'

export const HeroText = ({ contentHeadline, contentWysiwyg }) => {
  return (
    <section className="py-10 bg-white md:py-12 lg:py-16">
      <div className="container flex flex-wrap">
        <div className="w-full ml-4 lg:w-7/12 sm:ml-16 md:ml-24 lg:ml-0 lg:flex lg:justify-center lg:flex-col">
          <h1 className="font-sans text-4xl font-bold leading-tight tracking-wider uppercase text-brand-red sm:text-5xl">
            {contentHeadline}
          </h1>
          <div
            className="max-w-sm mt-3 text-lg leading-normal prose text-gray-500 lg:max-w-2xl sm:text-2xl lg:text-xl xl:text-2xl"
            dangerouslySetInnerHTML={{ __html: contentWysiwyg }}
          ></div>
        </div>
      </div>
    </section>
  )
}
